module.exports = __webpack_public_path__ + "img/businessProfile.c6af730b.svg";